const ASSESSMENT_ID_KEY = "hrm_appraisal_assessment_id";

/** Persist staff appraisal id for /appraisal/assessment (not shown in the URL). */
export function setAppraisalAssessmentId(id) {
  if (id == null || id === "") return;
  try {
    sessionStorage.setItem(ASSESSMENT_ID_KEY, String(id));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getAppraisalAssessmentId() {
  try {
    return sessionStorage.getItem(ASSESSMENT_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function clearAppraisalAssessmentId() {
  try {
    sessionStorage.removeItem(ASSESSMENT_ID_KEY);
  } catch {
    /* ignore */
  }
}
